// libs
import styled from "@emotion/styled";

// constants
import { DWEB_MAX_WIDTH } from "shared/styles/base";

export const Container = styled.div<{ marginTop?: number }>`
    width: 100%;
    margin-bottom: 20px;
    max-width: ${DWEB_MAX_WIDTH}px;
    margin: auto;

    ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px`}
`;

export const InFocusContainer = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;
    width: 100%;
    max-width: ${DWEB_MAX_WIDTH}px;
    margin: 0 auto;
    padding: 5px;
    align-items: center;
    position: relative;
`;
